export type CodeList = { [key in CodeTypeNames]?: CodeElement[] };

export type CodeListNormalized = {
  [key: string]: CodeElement;
};

export interface CodeElement {
  code: number;
  abbr?: string;
  description1: string;
  description2?: string;
  description3?: string;
  value1?: number;
  inActive?: boolean;
}

export enum CodeTypeNames {
  batchKindCodes = 'batchKindCodes',
  currencyCodes = 'currencyCodes',
  fileTypeCodes = 'fileTypeCodes',
  groupClassCodes = 'groupClassCodes',
  herdManagementSoftwareCodes = 'herdManagementSoftwareCodes',
  hmsDateLocationCodes = 'hmsDateLocationCodes',
  hmsFileFormatCodes = 'hmsFileFormatCodes',
  ingredientTypeCodes = 'ingredientTypeCodes',
  lineStatusCodes = 'lineStatusCodes',
  lineTypeCodes = 'lineTypeCodes',
  loadingTypeCodes = 'loadingTypeCodes',
  lotClassCodes = 'lotClassCodes',
  lotMarketClassCodes = 'lotMarketClassCodes',
  lotMovementTypeCodes = 'lotMovementTypeCodes',
  lotSexCodes = 'lotSexCodes',
  lotStatusCodes = 'lotStatusCodes',
  mixerBrandCodes = 'mixerBrandCodes',
  mixerRoleCodes = 'mixerRoleCodes',
  mixerServiceTypeCodes = 'mixerServiceTypeCodes',
  mixerStatusCodes = 'mixerStatusCodes',
  mtChangeKindCodes = 'mtChangeKindCodes',
  mtConditionCodes = 'mtConditionCodes',
  priceUnitCodes = 'priceUnitCodes',
  shrinkageTypeCodes = 'shrinkageTypeCodes',
  stockChangeStatusCodes = 'stockChangeStatusCodes',
  stockChangeTypeCodes = 'stockChangeTypeCodes',
  taskRecurringTypeCodes = 'taskRecurringTypeCodes',
}
